import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { SystemActions } from "redux-store";

// TODO: Move all logic start app to this component
const HandleStartApp = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(SystemActions.executeQueueLogout());
  }, []);

  return null;
};

export default HandleStartApp;
